import {combineReducers} from 'redux';
import modalStatus from './modalStatus'
import permissao from './permissao'
import agendaReducer from './agendaReducer';

export default combineReducers({
    modalStatus,
    agendaReducer,
    permissao
});